import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    // 🧹 Clear login data
    localStorage.removeItem("isLoggedIn"); // ✅ correct key
    sessionStorage.clear();

    // 🔁 Redirect to login
    navigate("/dhanlaxmiMyAdmin/login");
  }, [navigate]);

  return (
    <div className="logout-page">
      <h2>લોગઆઉટ થઈ રહ્યું છે...</h2>
    </div>
  );
}